import {
  take,
  fork,
  call,
  put,
  select,
} from 'redux-saga/effects';

import { apiGet } from './callApi';

import actionTypes from '../actionTypes';
import { getToken } from '../selectors';
import { failRacesLeaderboard, successRacesLeaderboard } from '../actionCreators/racesLeaderboard';

import apiRoutes from '../../constants/apiRoutes';

function* getRacesLeaderboard(limit: number, offset:number, raceId: number): any {
  try {
    const headers = {};
    const token = yield select(getToken);

    headers['x-access-token'] = JSON.stringify(token);
    yield put({ type: actionTypes.RACES_LEADERBOARD_LOADER });
    if(raceId) {
      const response = yield call(apiGet, 'REACT_APP_GAMEBOX_URL',
          apiRoutes.GET_RACES_LEADERBOARD, { token, raceId: raceId, limit, offset }, headers);
      if (response.data.success) {
        yield put(successRacesLeaderboard(response?.data?.result));
      } else {
        yield put(failRacesLeaderboard(response?.data?.message));
      }
    }
  } catch (e) {
    yield put(failRacesLeaderboard(e));
  }
}

export default function* watchRacesLeaderboardRequest(): any {
  while (true) {
    const action = yield take([
      actionTypes.RACES_LEADERBOARD_REQUEST,
      actionTypes.JOIN_TO_RACE_SUCCESS
    ]);
    yield fork(getRacesLeaderboard, action.limit, action.offset, action.raceId);
  }
}
